import React, {PureComponent} from 'react';
import OnClickToastInterface from '../../interfaces/OnClickToastInterface';
import logEvent from '../../amplitude/log_event';
import {NOTIFICATION_INTERACTION} from './BaseToast';
import SpriteIcon from 'app/utils/sprites/SpriteIcon';

export class CloseButton extends PureComponent<OnClickToastInterface> {
    onClick = (e: React.MouseEvent<HTMLButtonElement>): void => {
        e.stopPropagation();
        this.props.closeToast();
        if (this.props.data) {
            logEvent(NOTIFICATION_INTERACTION, {
                interaction: 'closed',
                types: this.props.data.type
            });
        }
        this.props.onClick && this.props.onClick();
    };

    render(): React.ReactNode {
        return <button
            className="Toastify__close-button"
            type="button"
            aria-label="close"
            onClick={this.onClick}
        >
            <SpriteIcon name="#svg-close" size={{height: 12, width: 12}}/>
        </button>;
    }
}
